module.exports = __webpack_public_path__ + "static/img/guan6.e724804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guan6.png
// module id = 9WT6
// module chunks = 36